const $html = $("html")
const $body = $("body")
const $layout = $("[data-menu=layout]")
const $layoutOverlay = $("[data-menu=layout-overlay]")
const $menu = $("[data-menu=menu]")
const $item = $("[data-menu=item]")
const $btnOpen = $("[data-menu=btn-open]")
const $btnClose = $("[data-menu=btn-close]")
let isOpened

const menuToggle = () => {
  $menu.toggleClass("_is-opened")
  $layout.toggleClass("_is-moved")
  $body.toggleClass("_noscroll")
  $html.toggleClass("_noscroll")
}

const onScroll = () => {
  $layout.on("scroll mousewheel touchmove", (event) => event.preventDefault())
}

const offScroll = () => {
  $layout.off("scroll mousewheel touchmove")
}

const openMenu = () => {
  menuToggle()
  onScroll()
}

const closeMenu = () => {
  menuToggle()
  offScroll()
}

$btnOpen.on("click", openMenu)

$btnClose.on("click", closeMenu)

$item.on("click", closeMenu)

$layoutOverlay.on("click", () => {
  isOpened = $menu.hasClass("_is-opened")
  if (isOpened) closeMenu()
})

$(document).on("keyup", (e) => {
  isOpened = $menu.hasClass("_is-opened")
  if (e.keyCode === 27 && isOpened) closeMenu()
})



// WEBPACK FOOTER //
// ./src/blocks/menu/menu.js